'use strict';

var helpers = {};

helpers.removeAriaLabels = function() {
  const classList = '.tns-controls, .tns-carousel.tns-slider, .tns-nav, .slider-thumbnail-controls';
  $('body').on('slider:init.sliderEvents', (event, $sliderContainer) => {
    $sliderContainer.find(classList).removeAttr('aria-label');
  });
  $(classList).removeAttr('aria-label');
};

helpers.handlePreferNotToSay = function() {
    const $checkBox = $('.js-check-ethnicity').find('input[type="checkbox"]');
    const preferNotToSayId = 'raceOption8';

    if (!!$checkBox.length) {
      $checkBox.on('change', function() {
        if ($(this).attr('id') === preferNotToSayId) {
          $checkBox.not($(this)).prop('checked', false);
        } else {
          $checkBox.closest(`#${preferNotToSayId}`).prop('checked', false)
        }
      });
    }
}


module.exports = helpers;
